import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const publicacoesAPI = {
  getAll: (produto) => api.get(`/publicacoes${produto ? `?produto=${produto}` : ''}`),
  getById: (id) => api.get(`/publicacoes/${id}`),
};

export const noticiasAPI = {
  getAll: (produto) => api.get(`/noticias${produto ? `?produto=${produto}` : ''}`),
  getById: (id) => api.get(`/noticias/${id}`),
};

export const perguntasAPI = {
  getAll: (produto) => api.get(`/perguntas${produto ? `?produto=${produto}` : ''}`),
  getById: (id) => api.get(`/perguntas/${id}`),
};

export const parceirosAPI = {
  getAll: () => api.get('/parceiros'),
};

export default api;
